import { IRouteResolver } from '../types';
import { ResolverType } from '../resolver-types.enum';

export interface UserValidationRouteParams {
    userId: string;
    userKey: string;
    validationTypeId: string;
}

export class UserValidationRouteResolver implements IRouteResolver {
    public pattern: RegExp = /^\/u\/users\/(\d+)\/([a-fA-F0-9]+)\/([a-zA-Z0-9_-]+)(?:\?.*)?$/;
    public type: ResolverType = ResolverType.USER_VALIDATION;

    public resolve(match: RegExpMatchArray): UserValidationRouteParams {
        return {
            userId: match[1],
            userKey: match[2],
            validationTypeId: match[3]
        };
    }
}
